import { idValues } from 'utils/arrays.js';
import messages from './messages.js';

function getLockedMessage(meetingSet, studentId) {
  const { meetings, blocks } = meetingSet;
  const meeting = idValues(meetings).find((mt) => mt.studentId === studentId);
  if (!meeting) {
    return null;
  }
  if (meeting.videoMeeting && meeting.videoMeeting.link) {
    return messages.hasVideoLink;
  }
  if (idValues(blocks).flatMap((b) => b.timeslots).filter((s) => s.meetingId === meeting.id).some((s) => s.locked)) {
    return messages.assignedByTeacher;
  }
  return null;
}

export default getLockedMessage;
